import gql from 'graphql-tag';

//login
export const AUTH_TOKEN = gql`
	mutation tokenAuth($email: String!, $password: String!) {
		tokenAuth(email: $email, password: $password) {
			token
			user {
				id
				firstName
				lastName
				email
			}
		}
	}
`;
// current user
export const GET_CURRENT_USER_QUERY = gql`
	query me {
		me {
			id
			firstName
			lastName
			email
		}
	}
`;

// forgot-password
export const SEND_EMAIL_FOR_RESET_PASSWORD = gql`
	mutation createResetToken($email: String!, $typeApp: Int!) {
		createResetToken(email: $email, typeApp: $typeApp) {
			user {
				id
				firstName
				lastName
				email
			}
		}
	}
`;

// reset-password
export const VERIFY_RESET_TOKEN = gql`
	mutation verifyResetToken($guid: String!) {
		verifyResetToken(guid: $guid) {
			user {
				id
				email
				firstName
				lastName
			}
		}
	}
`;

export const CHANGE_PASSWORD_WITH_TOKEN = gql`
	mutation changePasswordWithToken(
		$email: String!
		$guid: String!
		$newPassword: String!
	) {
		changePasswordWithToken(
			email: $email
			guid: $guid
			newPassword: $newPassword
		) {
			user {
				id
				firstName
				lastName
				email
			}
		}
	}
`;
